/**
 * Per-status badge theme + icon for donation transaction statuses.
 *
 * Shared by the donation detail title badge (DonationDetailView) and the editable
 * "Statut" select on the Details tab (DonationTabDetails) so the colour + icon mapping
 * lives in one place. Mirrors the Figma "Record View" status badge: success/100 bg +
 * a filled `check-fill` for the validated state. Only `Validated` is Figma-confirmed;
 * the other icons are sensible filled-icon defaults pending their own frames.
 */
export const donationStatusTheme = {
    Promesse: "neutral", // pledge — payment not yet received
    Recorded: "orange",
    Validated: "green",
    Rejected: "red",
    Canceled: "red",
    Refunded: "yellow",
};
export const donationStatusIcon = {
    Promesse: "ri-hand-heart-fill",
    Recorded: "ri-time-fill",
    Validated: "ri-check-fill",
    Rejected: "ri-close-circle-fill",
    Canceled: "ri-forbid-fill",
    Refunded: "ri-refund-2-fill",
};
